export const SADMIN_ADMIN_CREATE_REQUEST = "SADMIN_ADMIN_CREATE_REQUEST";
export const SADMIN_ADMIN_CREATE_SUCCESS = "SADMIN_ADMIN_CREATE_SUCCESS";
export const SADMIN_ADMIN_CREATE_FAIL = "SADMIN_ADMIN_CREATE_FAIL";
export const SADMIN_ADMIN_CREATE_RESET = "SADMIN_ADMIN_CREATE_RESET";

export const SADMIN_ADMIN_LIST_REQUEST = "SADMIN_ADMIN_LIST_REQUEST";
export const SADMIN_ADMIN_LIST_SUCCESS = "SADMIN_ADMIN_LIST_SUCCESS";
export const SADMIN_ADMIN_LIST_FAIL = "SADMIN_ADMIN_LIST_FAIL";

export const SADMIN_ADMIN_VIEW_REQUEST = "SADMIN_ADMIN_VIEW_REQUEST";
export const SADMIN_ADMIN_VIEW_SUCCESS = "SADMIN_ADMIN_VIEW_SUCCESS";
export const SADMIN_ADMIN_VIEW_FAIL = "SADMIN_ADMIN_VIEW_FAIL";

export const SADMIN_ADMIN_PERMISSIONS_REQUEST = "SADMIN_ADMIN_PERMISSIONS_REQUEST";
export const SADMIN_ADMIN_PERMISSIONS_SUCCESS = "SADMIN_ADMIN_PERMISSIONS_SUCCESS";
export const SADMIN_ADMIN_PERMISSIONS_FAIL = "SADMIN_ADMIN_PERMISSIONS_FAIL";

export const SADMIN_ADMIN_UPDATE_BRAND_REQUEST = "SADMIN_ADMIN_UPDATE_BRAND_REQUEST";
export const SADMIN_ADMIN_UPDATE_BRAND_SUCCESS = "SADMIN_ADMIN_UPDATE_BRAND_SUCCESS";
export const SADMIN_ADMIN_UPDATE_BRAND_FAIL = "SADMIN_ADMIN_UPDATE_BRAND_FAIL";

export const SADMIN_LOGS_LIST_REQUEST = "SADMIN_LOGS_LIST_REQUEST";
export const SADMIN_LOGS_LIST_SUCCESS = "SADMIN_LOGS_LIST_SUCCESS";
export const SADMIN_LOGS_LIST_FAIL = "SADMIN_LOGS_LIST_FAIL";
